// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"card"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M7 4H17V20H7V4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M3 6V18H7V6H3Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M21 6V18H17V6H21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M3 6V18H7V6H3Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M21 6V18H17V6H21Z","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 4H17V20H7V4Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-card')
export default class CardIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'card',
    }
  }
}
